import styled from '@emotion/styled';
import { RichDropdownMenu } from '@liveoptics/react-ui';
import React, { FormEvent, useCallback } from 'react';
import { Opportunity } from '../../../interfaces';

export interface OpportunitiesDropDownMenuProps {
  defaultValue?: number;
  opportunities: Opportunity[];
  disabled: boolean;
  onChange?: (value: number) => void;
}

const StyledDropDownMenu = styled(RichDropdownMenu)`
  width: 100% !important;
  ul {
    max-height: 200px !important;
  }
`;

export const OpportunitiesDropDownMenu = (props: OpportunitiesDropDownMenuProps) => {
  const handleChange = useCallback(
    (option: FormEvent<HTMLDivElement> & { value: string | number; label: string }) => {
      if (props.onChange) {
        if (typeof option.value === 'number') props.onChange(option.value);
        if (typeof option.value === 'string') props.onChange(parseInt(option.value));
      }
    },
    [props]
  );

  const opportunities = props.opportunities.map((o) => {
    return { value: o.Id, label: o.Name + ' : ' + o.Id, disabled: false };
  });
  opportunities.unshift({ value: '-1', label: 'Select', disabled: true });
  return (
    <StyledDropDownMenu
      disabled={props.disabled}
      value={props.defaultValue ? props.defaultValue.toString() : '-1'}
      onChange={handleChange}
      options={opportunities}
    />
  );
};
